import React from 'react';
import { Link } from 'react-router-dom';
import download_app from '../../assets/img/download_app.png'
import { UI_BASE_URL } from '../../utils/Constants';


const Download = () => {

    return (
        <>
            <div className="banner_bg_download position-absolute top-0 start-0"></div>
            <div className='container'>
                <div className=" banner_download d-flex align-items-center" style={{ marginBottom: "-10px" }}>
                    <div className="container">
                        <div className='row'>
                            <div className='col-sm-12 col-md-6'>
                                <h2 className="mb-2 download_head">Get the new App for
                                    iPhone & Android</h2>
                                <p className="mb-3">Discover the convenience of our fantastic Nanny App, designed to make finding trusted childcare easier than ever! With just a few taps, you can browse, book, and manage top-rated nannies in your area, all while receiving real-time updates and direct communication. Whether you need a last-minute sitter or long-term care, our app offers a seamless experience, ensuring peace of mind and quality care for your family. Download today and enjoy stress-free childcare at your fingertips!</p>
                                <div className='android_ios_btn'>
                                    {/* <div>
                                        <Link to="#" className="btn btn-book mt-2 position-relative">Download for iOS</Link>
                                    </div> */}
                                    <div>
                                        <a
                                            href={`https://apps.apple.com/in/app/the-nanny-line/id6460080225`}
                                            className="btn btn-book mt-2 position-relative"
                                            download
                                        >
                                            Download for iOS
                                        </a>
                                    </div>
                                    <div>
                                        <a
                                            href={`${UI_BASE_URL}/nanny-line.apk`}
                                            className="btn btn-book mt-2 position-relative"
                                            download
                                        >
                                            Download for Android
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12 col-md-6 mobile_app_img'>
                                <div style={{ textAlign: 'center' }}>
                                    <img src={download_app} alt='download_app' style={{ width: '300px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Download